import PointsSideModal from "./PointsSideModal";

export default PointsSideModal;